import { Button, Form, Input, message } from "antd";
import React, { useState } from "react";
import BackgroundImg from "../../Assets/Images/background.jpg";
import { Helmet } from "react-helmet-async";
import Logo from "../../Assets/Images/logo.png";
import { postRequest } from "../../Utils/ApiCalls";
import { navigateTo, version } from "../../Utils/Common";
import PersistentFooter from "../../Components/PersistentFooter/PersistentFooter";

const Login = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  async function onFinish(values: any) {
    setLoading(true);
    var response;

    response = await postRequest(`login`, values, true);

    if (response.success) {
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("id", response.data.user_id);
      localStorage.setItem("role_id", response.data.role_id);
      localStorage.setItem("branch_id", response.data.branch_id);
      localStorage.setItem("role", response?.data?.role_name?.toLowerCase());
      localStorage.setItem("full_name", response.data.name);
      message.success("Logged in successfully!");
      setTimeout(() => {
        // if (rest.is_changed === "1") {
        //   navigateTo("/agent");
        // } else {
        //   navigateTo("/reset-password");
        // }
        navigateTo("/daily-sales-report");
      }, 1000);
    } else {
      message.error(
        response?.data?.response?.data?.messages?.error_messages[0] ??
          "An error occured. Please try again later."
      );
    }
    setLoading(false);
  }

  return (
    <div>
      <div className="main-container">
        <Helmet>
          <title>Agua Lab ERP System</title>
        </Helmet>
        <div className="flex flex-row w-full h-full">
          <div className="w-full hidden md:flex overflow-hidden">
            <img
              src={BackgroundImg}
              alt=""
              className="w-full h-full object-cover object-left"
            />
          </div>
          <div className="w-full flex flex-col justify-center">
            <div className="m-10 lg:m-[9rem] flex flex-col justify-center items-center">
              <img src={Logo} alt="" className="w-36 mb-2" />
              <p className="text-2xl font-bold">Welcome!</p>
              <p className="text-gray-600 mt-2 mb-5 text-sm">
                Enter your username and password to access your account.
              </p>
              <Form
                form={form}
                onFinish={onFinish}
                // onFinish={() => {
                //   navigateTo("/dashboard");
                // }}
                layout="vertical"
                autoComplete="off"
                className="w-full"
              >
                <Form.Item
                  name="username"
                  label="Username"
                  className="w-full"
                  rules={
                    [
                      { required: true, message: "Email is required" },
                      // { type: "email", message: "Enter a valid email" },
                    ]
                  }
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="password"
                  label="Password"
                  className="w-full"
                  rules={[{ required: true, message: "Password is required" }]}
                >
                  <Input.Password type="password" />
                </Form.Item>
                <Form.Item className="mt-10 mb-3">
                  <Button
                    htmlType="submit"
                    type="primary"
                    className="w-full rounded-[10rem] py-3"
                    loading={loading}
                    // onClick={() => {
                    //   navigateTo("/daily-sales-report");
                    // }}
                  >
                    Login
                  </Button>
                </Form.Item>
                <div className="text-center text-gray-500 mt-5 flex flex-col gap-2 text-xs">
                  <span>{version}</span>
                  {/* <span>Last updated on July 14, 2025</span> */}
                </div>
              </Form>
            </div>
          </div>
        </div>
        <PersistentFooter />
      </div>
    </div>
  );
};

export default Login;
